import React from "react";
import {
  breakpointClasses,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { SectionProps } from "./types";

function Section<E extends React.ElementType = "section">({
  as,
  asChild,
  id,
  padding = "~py-6/12",
  margin = "",
  background = "",
  className,
  ...props
}: SectionProps<E>) {
  const Component = resolveElement(asChild, as, "section");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Section] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      id={`${id ? `${id}-` : ""}section`}
      className={cn(
        "w-full h-full",
        padding,
        margin,
        background,
        className,
        classes,
      )}
      {...native}
    />
  );
}

export default Section;
